module.exports = __webpack_public_path__ + "media/andenes/manual_dim_ramp-ea566eb7.webp";